import { useApi } from '@pidz/api';

const api = useApi();

export const faqService = {
  getFaq: (): Promise<Faq[]> => api.jsonrpc({
    url: 'faq:getFAQ',
  }),
}
